import React from "react";
import compose from "recompose/compose";
import Card from "@material-ui/core/Card";
import TocIcon from "@material-ui/icons/Toc";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { translate } from "react-admin";

import CardIcon from "./cardIcon";

const styles = {
  main: {
    flex: "1",
    marginLeft: "1em",
    marginTop: 20
  },
  card: {
    overflow: "inherit",
    textAlign: "right",
    padding: 16,
    minHeight: 52
  }
};

// @ts-ignore
const Keywords = ({ value, translate, classes }) => (
  <div className={classes.main}>
    <CardIcon Icon={TocIcon} bgColor="#ff9800" />
    <Card className={classes.card}>
      <Typography className={classes.title} color="textSecondary">
        Keywords
      </Typography>
      <Typography variant="headline" component="h2">
        {value}
      </Typography>
    </Card>
  </div>
);

const enhance = compose(
  // @ts-ignore
  withStyles(styles),
  translate
);
// @ts-ignore
export default enhance(Keywords);
